// extracted by mini-css-extract-plugin
export var equalColumn = "_fr-0";